<h2>Settings</h2>
<div fxLayout="column" fxLayoutGap="1rem">
    <mat-card>
        <h3>Change Password</h3>
        <mat-spinner *ngIf="changePasswordLoading" style="margin:0 auto;"></mat-spinner>
        <form *ngIf="!changePasswordLoading" [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" fxLayoutAlign="start stretch" fxLayout="column" fxLayoutGap="0.5rem">
            <mat-form-field>
                <mat-label>Current Password</mat-label>
                <input type="password" formControlName="password" name="password" matInput placeholder="Password">
                <mat-error *ngIf="password.hasError('required')">Current Password is required</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>New Password</mat-label>
                <input type="password" formControlName="newPassword" name="newPassword" matInput placeholder="New Password" (input)="onNewPasswordInput()">
                <mat-error *ngIf="newPassword.hasError('required')">New Password is required</mat-error>
                <mat-error *ngIf="newPassword.hasError('minlength')">New Password must have at least 8 characters</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Confirm New Password</mat-label>
                <input type="password" formControlName="confirmNewPassword" name="confirmNewPassword" matInput placeholder="Confirm New Password" (input)="onNewPasswordInput()">
                <mat-error *ngIf="confirmNewPassword.hasError('required')">Confirm New Password is required</mat-error>
                <mat-error *ngIf="confirmNewPassword.invalid && !confirmNewPassword.hasError('required')">New Password and Confirm New Password do not match</mat-error>
            </mat-form-field>
            <button type="submit" mat-flat-button [disabled]="changePasswordForm.invalid" color="primary">Submit</button>
        </form>
    </mat-card>
    <mat-card>
        <h3>Update Avatar</h3>
        <form [formGroup]="changeAvatarForm" (ngSubmit)="changeAvatar()" fxLayoutAlign="start stretch" fxLayout="column" fxLayoutGap="0.5rem" *ngIf="!changeAvatarInitializing">
            <mat-form-field>
                <mat-label>Ready Player Me Avatar URL</mat-label>
                <input type="text" formControlName="avatarURL" name="avatarURL" matInput placeholder="Ready Player Me Avatar URL">
                <mat-error *ngIf="avatar.hasError('pattern')">Invalid</mat-error>
            </mat-form-field>
            <button type="submit" mat-flat-button [disabled]="changeAvatarForm.invalid || changeAvatarLoading" color="primary">Submit</button>
        </form>
        <mat-progress-bar *ngIf="changeAvatarInitializing || changeAvatarLoading" mode="indeterminate"></mat-progress-bar>
    </mat-card>
</div>